import React, { useEffect, useMemo, useRef, useState } from "react";
import { Tabs, Tab, Box, Container, Paper, useTheme } from "@mui/material";
// import Explore from "./Explore";
// import Feeds from "./Feeds";
// import OnlyCommunity from "./OnlyCommunity";
// import EventCard from "./EventCard";
// import Blogs from "./Blogs/Blogs";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getFeeds,
  getMyFeeds,
  getRegisteredAttendees,
} from "../../../../Redux/Reducers/communityReducer";
// import OnlyMyEvents from "../../../../Community/OnlyMyEvents";
import MyFeeds from "../Feeds/MyFeeds";
import MyEvents from "../Events/MyEvents";
import BookedEvents from "../Events/BookedEvents";
import { useSelector } from "react-redux";
import VolunteerScreen from "../Events/VolunteerScreen";



const CommunityProfileTabs = ({ setIsProfile }) => {
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState("second");
  const contentRef = useRef(null);
  const theme = useTheme();
  const dispatch = useDispatch();
  const exploreType = useSelector((state) => state?.community?.exploreType);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");
    if (tab) {
      setCurrentTab(tab);
    }
  }, [location.search]);

  useEffect(() => {
    const payload = { type: exploreType, my_posts: true };
    dispatch(getFeeds(payload));
    dispatch(getMyFeeds({ type: exploreType }));
    dispatch(getRegisteredAttendees({ type: exploreType }));
  }, [dispatch]);

  const routes = useMemo(
    () => [
      // { key: "first", title: "Explore", component: <Explore /> },
      { key: "second", title: "My Posts", component: <MyFeeds /> },
      // { key: "third", title: "My Communities", component: <OnlyCommunity /> },
      { key: "fourth", title: "My Events", component: <MyEvents /> },
      // { key: "fifth", title: "My Blogs", component: <Blogs /> },
      {
        key: "sixth", title: "Booked Events",component: <BookedEvents />,
      },
      {
        key: "seventh", title: "Assigned Events",component: <VolunteerScreen />,
      },
    ],
    []
  );

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);

    if (contentRef?.current) contentRef.current.scrollTop = 0;
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      // Load more data here
      // Example: fetchMoreData();
    }
  };

  return (
    // <Container maxWidth="lg">
    <Box sx={{ width: "100%",  }}>
      <Paper
        elevation={1}
        sx={{
          borderRadius: 1,
          backgroundColor: "#fff",
          mb: 1,
          overflow: "hidden",
          marginTop:'10px'
        }}
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Navigation tabs"
          TabIndicatorProps={{
            style: {
              height: 4,
              borderRadius: 1,
              backgroundColor: theme.palette.primary.main,
            },
          }}
          sx={{
      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },
    }}
        >
          {routes?.map((route) => (
            <Tab
              key={route.key}
              label={route.title}
              value={route.key}
              sx={{
                textTransform: "none",
                fontWeight: currentTab === route.key ? "bold" : 500,
                color:
                  currentTab === route.key
                    ? theme.palette.primary.main
                    : "#0044C6",
                fontSize: 16,
                px: 2,
              }}
            />
          ))}
        </Tabs>
      </Paper>
      <Box
        ref={contentRef}
        sx={{
          height: "70vh", // Adjust as needed
          overflowY: "scroll",
          scrollbarWidth: "none",
          backgroundColor: "#F4F7FE",

        }}
        onScroll={handleScroll}
      >
        {routes?.map((route) => (
          <TabPanel
            key={route.key}
            value={route.key}
            currentTab={currentTab}
            padding={0}
          >
            {route.component}
          </TabPanel>
        ))}
      </Box>
    </Box>
    // </Container>
  );
};

// Tab panel component
function TabPanel(props) {
  const { children, value, currentTab, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== currentTab}
      id={`tabpanel-${value}`}
      aria-labelledby={`tab-${value}`}
      {...other}
    >
      {value === currentTab && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

export default CommunityProfileTabs;
